export {default as klarnaEnabled} from './klarnaEnabled'



// WEBPACK FOOTER //
// ./src/components/klarnaEnabled/index.js